<template>
  <div>
    <Dialog v-if="state.visible" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common" :showClose="props.data.type === 'not-start' ? false : true">
      <div class="dialog" :class="cssType + ' ' + data.type">
        <div class="dialog-wrapper">
          <div class="dialog-desc">
            {{ data.type === 'ended' ? $t('sf.ended') : $t('sf.notStart') }}
          </div>
          <div class="dialog-content">
            <div v-if="data.type === 'ended'">
              <!-- {{ $t('payment.ended') }} -->
            </div>
            <div v-else-if="data.type === 'not-start'">
              [{{ $t('sf.startCountdown') }}]
              <br v-if="locale === 'vi'" />
              <span class="countdown-wrapper">
                {{ startCountdown.day }} {{ $t('sf.day') }} {{ startCountdown.hour }}:{{ startCountdown.minute }}:{{ startCountdown.second }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, reactive, nextTick, computed, inject, onBeforeUnmount } from 'vue'
import { isMobile } from '@/utils'
import Dialog from '@/components/Dialog/ActSf/index.vue'
import { useI18n } from 'vue-i18n'
const cssType = isMobile ? 'mobile' : 'pc'
const globalConfig = inject('globalConfig', { commonConfig: {} })
const { locale } = useI18n()

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => {}
  },
  cb: {
    type: Function,
    default: () => {}
  }
})

const state = reactive({
  visible: false,
  seconds: 0,
  timer: null,
  isInitialized: false
})

// 初始化倒计时
const initCountdown = () => {
  if (state.isInitialized) {
    return
  }
  
  if (globalConfig?.commonConfig?.serverTime) {
    state.isInitialized = true
    
    // 开始倒计时
    if (!state.timer) {
      countDown()
    }
  }
}

// 监听 globalConfig.commonConfig 的变化
watch(
  () => globalConfig?.commonConfig,
  (newVal) => {
    if (newVal && newVal.serverTime && !state.isInitialized) {
      initCountdown()
    }
  },
  { immediate: true, deep: true }
)

// 监听 serverTime 的变化
watch(
  () => globalConfig?.commonConfig?.serverTime,
  (newVal) => {
    if (newVal && !state.isInitialized) {
      initCountdown()
    }
  },
  { immediate: true }
)

const countDown = () => {
  if (state.timer) {
    return
  }
  state.timer = setInterval(() => {
    state.seconds++
  }, 1000)
}

watch(() => props.modelValue, (newVal) => {
  nextTick(() => {
    state.visible = newVal
    // 当对话框打开时，重新初始化倒计时
    if (newVal && props.data.type === 'not-start') {
      if (!state.isInitialized) {
        initCountdown()
      } else if (!state.timer) {
        // 如果已初始化但定时器被清理了，重新启动
        countDown()
      }
    } else {
      // 对话框关闭时，清理定时器以节省资源
      if (state.timer) {
        clearInterval(state.timer)
        state.timer = null
      }
    }
  })
}, {
  immediate: true
})

onBeforeUnmount(() => {
  if (state.timer) {
    clearInterval(state.timer)
    state.timer = null
  }
})

// 计算时间差（秒）
const countdownDiff = computed(() => {
  if (!globalConfig?.commonConfig?.activityStartTime || !globalConfig?.commonConfig?.serverTime || !state.isInitialized) {
    return -1
  }
  
  const activityStartTime = globalConfig.commonConfig.activityStartTime
  // 确保是秒时间戳
  const startTimeSeconds = activityStartTime > 10000000000 ? Math.floor(activityStartTime / 1000) : activityStartTime
  
  // 计算当前服务器时间（秒）= 初始服务器时间 + 已过秒数
  const currentServerTime = (globalConfig.commonConfig.serverTime > 10000000000 
    ? Math.floor(globalConfig.commonConfig.serverTime / 1000) 
    : globalConfig.commonConfig.serverTime) + state.seconds
  
  // 计算时间差（秒）
  return Math.max(0, startTimeSeconds - currentServerTime)
})

// 计算开始倒计时
const startCountdown = computed(() => {
  const res = {
    day: '0',
    hour: '00',
    minute: '00',
    second: '00',
  }
  
  const diff = countdownDiff.value
  if (diff < 0) {
    return res
  }
  
  // 转换为天、时、分、秒
  const day = Math.floor(diff / 86400)
  const hour = Math.floor((diff % 86400) / 3600)
  const minute = Math.floor((diff % 3600) / 60)
  const second = diff % 60

  res.day = day
  res.hour = hour >= 10 ? hour : '0' + hour
  res.minute = minute >= 10 ? minute : '0' + minute
  res.second = second >= 10 ? second : '0' + second
  
  return res
})

// 监听倒计时，当倒计时到0时关闭弹窗
watch(
  () => countdownDiff.value,
  (diff) => {
    if (props.data.type === 'not-start' && diff === 0 && state.visible) {
      // 倒计时到0，关闭弹窗
      updateModelValue(false)
    }
  }
)

const emit = defineEmits(['update:modelValue'])

const updateModelValue = (value) => {
  emit('update:modelValue', value)
  props.cb && props.cb(value)
}

</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
